module.exports = __webpack_public_path__ + "media/reference3.81ead9cb.mp3";